'use strict';

const preventClick = [
  '$window',

  function ($window) {
    var document = $window.document;
    var documentEl = angular.element($window.document);
    var shouldPreventClick;
    var x;
    var y;

    documentEl.on('mousedown touchstart', function () {
      shouldPreventClick = false;
    });

    document.addEventListener('click', function ($event) {
      if (shouldPreventClick && x === $event.clientX && y === $event.clientY) {
        $event.preventDefault();
        $event.stopImmediatePropagation();
      }
    }, true);

    return function (event) {
      x = event.clientX;
      y = event.clientY;
      shouldPreventClick = true;
    };
  }
];

export default preventClick;



// WEBPACK FOOTER //
// ./app/src/services/prevent_click.js